import { z } from "zod";
import { FieldProps } from "react-final-form";
import { useState } from "react";
import { FormBase, customFieldProps, FormBaseProps, InputField, CheckboxField, SelectField } from "ui";
import { CompanyType } from "../../../__generated__/graphql";
import { splitEnumToDisplayCase } from "../../../tools/splitEnumToDisplayCase";

const companyTypes = [
    {
        value: CompanyType.School,
        label: splitEnumToDisplayCase(CompanyType.School)
    },
    {
        value: CompanyType.PrivateClinic,
        label: splitEnumToDisplayCase(CompanyType.PrivateClinic)
    },
    {
        value: CompanyType.Hospital,
        label: splitEnumToDisplayCase(CompanyType.Hospital)
    }, {
        value: CompanyType.Other,
        label: splitEnumToDisplayCase(CompanyType.Other)
    }
]
const COMPANY_FORM_FIELDS: customFieldProps[] = [
    {
        "name": "name",
        "label": "Company Name",
        component: InputField,
        required: true,
        fullWidth: true,
        grid: {
            xs: 6,
        },
    },
    {
        "name": "type",
        "label": "Company Type",
        component: SelectField,
        options: companyTypes,
        grid: {
            xs: 6
        }
    },
    {
        "name": "needParentalConsent",
        "label": "Parental Consent Needed",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 6
        }
    },
    {
        "name": "autoParentalConsent",
        "label": "Send Parental Consent Automatically",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 6
        },
        showIf: (values: any) => values.needParentalConsent === true
    },
    {
        "name": "timeoutWindow",
        "label": "Time out Window, if you receive no response",
        fullWidth: true,
        component: InputField,//NEED BOOLEAN FIELD,
        grid: {
            xs: 12
        },
        showIf: (values: any) => values.needParentalConsent === true
    },
    {
        "name": "abuseAtHome",
        "label": "Abuse At Home Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
    {
        "name": "safeAtHome",
        "label": "Safe at Home Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
    {
        "name": "suicide",
        "label": "Suicide Intervention Policy",
        type: "checkbox",
        component: CheckboxField,//NEED BOOLEAN FIELD
        grid: {
            xs: 4
        }
    },
]

const companyEditSchema = z.object({
    name: z.string().trim().nonempty().max(255),
    type: z.string().trim().nonempty().max(255),
    needParentalConsent: z.boolean(),
    autoParentalConsent: z.boolean(),
    timeoutWindow: z.number().int().nullable(),
    abuseAtHome: z.boolean(),
    safeAtHome: z.boolean(),
    suicide: z.boolean(),
})

export type CompanyFormSchema = z.infer<typeof companyEditSchema>;

type FormState = {
    fields: customFieldProps[];
}

// export type CompanyFormProps = {
//     onSubmit: (values: CompanyFormSchema) => Promise<ReturnType<FormSubmitCallback>>,
//     onCancel: () => void,
// } & Pick<FormBaseProps<CompanyFormSchema>, "initialValues" | "readonly">
export type CompanyFormProps = Pick<FormBaseProps<CompanyFormSchema>, "initialValues" | "readonly">
// export default function CompanyForm({ initialValues, readonly, onSubmit, onCancel }: CompanyFormProps) {
export default function CompanyForm({ initialValues, readonly }: CompanyFormProps) {

    const [formState, setFormState] = useState<FormState>({
        fields: COMPANY_FORM_FIELDS
    })
    const CompanyForm = FormBase<CompanyFormSchema>({
        fields: formState.fields,
        initialValues: initialValues ?? {},
        validationSchema: companyEditSchema,
        buttonSubmitLabel: "Save",
        buttonCancelLabel: "Cancel",
        readonly,
        // onSubmit: onSubmit,
        // onCancel: onCancel
    })
    return CompanyForm
}